// extracted by mini-css-extract-plugin
export default {"landing":"Main_landing__OZ6jo","go":"Main_go__6erCd","button":"Main_button__Dkaou","enter":"Main_enter__lurTW"};